import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from '../api/axios';
import { API_ENDPOINTS } from "../api/endpoint";
import { toast } from "react-toastify";

export const getChat = createAsyncThunk('chat/getChat', async (params = {}, { rejectWithValue }) => {
    const room_id = params?.room_id || 1;
    const url = `${API_ENDPOINTS.GET_CHAT}${room_id ? `?room_id=${room_id}` : ''}`;
    return axios({
        url: url,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
    })
        .then(response => {
            // Handle new format with messages, pinned_message, broadcasts, room_status
            if (response.data && response.data.messages) {
                const messages = response.data.messages.map(chatItem => {
                    // אם ההודעה מקודדת, ננסה לפענח אותה
                    if (chatItem.msg && typeof chatItem.msg === 'string' && chatItem.msg.includes('%')) {
                        try {
                            return {
                                ...chatItem,
                                msg: decodeURIComponent(chatItem.msg)
                            };
                        } catch (e) {
                            console.error("Error decoding message:", e);
                        }
                    }
                    return chatItem;
                });
                
                return {
                    messages: messages,
                    pinned_message: response.data.pinned_message,
                    broadcasts: response.data.broadcasts || [],
                    room_status: response.data.room_status
                };
            }
            // Fallback for old format (array)
            if (response.data && Array.isArray(response.data)) {
                return {
                    messages: response.data.map(chatItem => {
                        if (chatItem.msg && typeof chatItem.msg === 'string' && chatItem.msg.includes('%')) {
                            try {
                                return {
                                    ...chatItem,
                                    msg: decodeURIComponent(chatItem.msg)
                                };
                            } catch (e) {
                                console.error("Error decoding message:", e);
                            }
                        }
                        return chatItem;
                    }),
                    pinned_message: null,
                    broadcasts: [],
                    room_status: null
                };
            }
            return {
                messages: [],
                pinned_message: null,
                broadcasts: [],
                room_status: null
            };
        })
        .catch(error => {
            toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')
        });
});
export const getMailList = createAsyncThunk('chat/getMailList', async (_, { rejectWithValue }) => {
    return axios({
        url: `${API_ENDPOINTS.GET_MAIL_LIST}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => response.data)
        .catch(error => {
            toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')

        });
});

export const sendChat = createAsyncThunk('chat/sendChat', async (data, { rejectWithValue }) => {
    const encodedData = {
        ...data,
        msg: encodeURIComponent(data.msg),
        room_id: data.room_id || 1
    };

    try {
        const response = await axios({
            url: `${API_ENDPOINTS.SEND_CHAT}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            data: encodedData
        });
        return response.data;
    } catch (error) {
        const errorMsg = error?.response?.data?.error || error?.response?.data?.message || 'Failed to send message';
        toast.error(errorMsg);
        return rejectWithValue(errorMsg);
    }
});


const initialState = {
    all_chat: [],
    mail_list: [],
    pinned_message: null,
    broadcasts: [],
    room_status: null
}
export const chartSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChat.pending, (state, action) => {
                state.all_chat_loading = true;
                state.all_chat_error = null;
            })
            .addCase(getChat.fulfilled, (state, action) => {
                state.all_chat_loading = false;
                if (action.payload && action.payload.messages) {
                    state.all_chat = action.payload.messages;
                    state.pinned_message = action.payload.pinned_message;
                    state.broadcasts = action.payload.broadcasts || [];
                    state.room_status = action.payload.room_status;
                } else if (Array.isArray(action.payload)) {
                    // Fallback for old format
                    state.all_chat = action.payload;
                    state.pinned_message = null;
                    state.broadcasts = [];
                    state.room_status = null;
                }
            })
            .addCase(getChat.rejected, (state, action) => {
                state.all_chat_loading = false;
                state.all_chat_error = action.payload;
            })
            .addCase(sendChat.pending, (state, action) => {
                state.send_chat_loading = true;
                state.send_chat_error = null;
            })
            .addCase(sendChat.fulfilled, (state, action) => {
                state.send_chat_loading = false;
                // state.all_chat = action.payload
            })
            .addCase(sendChat.rejected, (state, action) => {
                state.send_chat_loading = false;
                state.send_chat_error = action.payload;
            })
            .addCase(getMailList.pending, (state, action) => {
                state.mail_loading = true;
                state.mail_error = null;
            })
            .addCase(getMailList.fulfilled, (state, action) => {
                state.mail_loading = false;
                state.mail_list = action.payload
            })
            .addCase(getMailList.rejected, (state, action) => {
                state.mail_loading = false;
                state.mail_error = action.payload;
            })


    }
})

export default chartSlice.reducer